import { Box, Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const VideographyModalContent: FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box sx={(theme) => ({ height: 250, bgcolor: theme.palette.background.paper })}>
        <iframe
          src="https://media.changeengine.com/v/07377ad3-2da4-42d5-ab7f-de281041fef0"
          title="video"
          width="100%"
          height="100%"
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
          allowFullScreen
          style={{ border: "none" }}
        />
      </Box>
      <Typography sx={{ mt: 2 }} variant="body2">
        Bring Your Culture to Life—Through Video.
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        {t(
          "You’ve built incredible programs—now let them shine. Video adds the emotion, energy, and connection your culture deserves. From onboarding to exec messages, milestones to celebrations, video makes every moment feel personal and unforgettable.",
        )}
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        {t(
          "Whether it’s a heartfelt welcome, a powerful testimonial, or a vibrant cultural highlight, video turns information into inspiration—and viewers into believers.",
        )}
      </Typography>
      <Typography sx={{ mt: 2 }} variant="body2">
        Don’t just tell your story. Show it.
      </Typography>
    </Box>
  );
};
